<template>
  <div class="header">
    <div class="logo-name">
      <img src="../assets/logo.webp" alt="logo">
      <span>豪嘉制冷</span>
    </div>

    <div class="nav">
      <div @click="handleMenuClick('home')">首页</div>
      <div @click="handleMenuClick('product')">产品中心</div>
      <div @click="handleMenuClick('company')">公司介绍</div>
      <div @click="handleMenuClick('support')">技术支持</div>
      <div @click="handleMenuClick('contact')">联系我们</div>
    </div>

    <!-- 汉堡菜单 -->
    <div class="hamburger" @click="toggleMenu">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>

    <!-- 移动端导航菜单 -->
    <transition name="slide">
      <div class="mobile-nav" v-show="isMenuOpen">
        <div @click="handleMenuClick('home'); closeMenu()">首页</div>
        <div @click="handleMenuClick('product'); closeMenu()">产品中心</div>
        <div @click="handleMenuClick('company'); closeMenu()">公司介绍</div>
        <div @click="handleMenuClick('support'); closeMenu()">技术支持</div>
        <div @click="handleMenuClick('contact'); closeMenu()">联系我们</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HeaderComp',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    handleClickOutside(event) {
      const menu = this.$el.querySelector('.mobile-nav');
      const hamburger = this.$el.querySelector('.hamburger');
      if (menu && hamburger && !menu.contains(event.target) && !hamburger.contains(event.target)) {
        this.closeMenu();
      }
    },
    toggleMenu() {
      event.stopPropagation();
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleMenuClick(id) {
      this.$emit('menu-click', id)
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped lang="scss">
.header {
  background: #FFF;
  display: flex;
  width: 100%;
  height: 80px;
  padding: 0px 32px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
}

.logo-name {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;

  color: #111827;
  font-family: "Inter";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
}

.logo-name img {
  height: 32px;
}

.nav {
  display: flex;
  align-items: center;
  gap: 32px;
  color: #111827;
  font-family: "Inter";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.nav div {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .header {
    padding: 0 16px;
    position: fixed;
  }

  .mobile-nav {
    top: 80px;
  }

  logo-name {
    font-size: 16px;
    gap: 4px;

    img {
      height: 24px;
    }
  }

  .nav {
    display: none;
  }

  .hamburger {
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;

    .bar {
      width: 24px;
      height: 2px;
      background: #111827;
      transition: all 0.3s ease;
    }
  }

  .mobile-nav {
    z-index: 100;
    position: absolute;
    top: 80px;
    right: 0;
    width: 120px;
    background: #FFF;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    div {
      padding: 8px 0;
      
    }
  }

  .slide-enter-active {
    animation: slideInDown 0.3s;
  }

  .slide-leave-active {
    animation: slideOutUp 0.3s;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOutUp {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-20px);
    opacity: 0;
  }
}
</style>